<template>
  <div>
    <div v-if="path == '/signin'">
      <app-register-of-signed-in></app-register-of-signed-in>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import RegisterOfSignedIn from "./RegisterOfSignedIn";

export default {
  components: {
    appRegisterOfSignedIn: RegisterOfSignedIn,
  },
  computed: {
    path() {
      return this.$route.path;
    },
  },
};
</script>

<style scoped></style>
